export var sessionToken = 'admnauthtkn';
export var userRoles = 'roles';
export var loginDefault = '';
export var passwordDefault = '';
